// extracted by mini-css-extract-plugin
module.exports = {"stylesCategories":"category_stylesCategories__3z8L3","linkDecoration":"category_linkDecoration__dLTHe","linkdecoration":"category_linkdecoration__2p211"};